/** 검색·공유에 쓰는 고정 오리진. apex(foreducator.com)와 www 중복을 막는다. */
export const CANONICAL_ORIGIN = "https://www.foreducator.com";
export const SITE_NAME = "Foreducator";

export const DEFAULT_TITLE =
  "Foreducator | 생기부·학급관리·시간표·교사 커뮤니티";
export const DEFAULT_DESCRIPTION =
  "교사를 위한 올인원 플랫폼. 생기부 문구·평가계획·서류 수합, 자리배치·출석·수업 퀴즈, 학교 시간표 자동 생성, 교사 커뮤니티까지 한곳에서.";
export const DEFAULT_KEYWORDS =
  "교사, 생기부, 학급관리, 자리배치, 출석부, 평가계획, 시간표 프로그램, 교사 커뮤니티, 수업 퀴즈, Foreducator";

export const SEO_OG = {
  home: "/og/2026/home.png",
  workmate: "/og/2026/workmate.png",
  classmate: "/og/2026/classmate.png",
  informate: "/og/2026/informate.png",
  community: "/og/2026/community.png",
  timetable: "/og/2026/timetable.png",
  guide: "/og/2026/guide.png",
} as const;

export function canonicalUrl(path: string): string {
  const pathname = path.split(/[?#]/, 1)[0];
  const p = `/${pathname.replace(/^\/+|\/+$/g, "")}`;
  return `${CANONICAL_ORIGIN}${p}`;
}

export function absoluteAssetUrl(pathOrUrl: string, origin = CANONICAL_ORIGIN): string {
  if (!pathOrUrl) return `${origin}${SEO_OG.home}`;
  if (pathOrUrl.startsWith("http://") || pathOrUrl.startsWith("https://")) return pathOrUrl;
  return `${origin}${pathOrUrl.startsWith("/") ? pathOrUrl : `/${pathOrUrl}`}`;
}

export function sectionOgImage(section?: string): string {
  switch (section) {
    case "workmate":
      return SEO_OG.workmate;
    case "classmate":
      return SEO_OG.classmate;
    case "informate":
      return SEO_OG.informate;
    case "community":
      return SEO_OG.community;
    case "timetable":
      return SEO_OG.timetable;
    default:
      return SEO_OG.guide;
  }
}
